import { ListItemButton, ListItemText } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import mallIcon from "../../../../assets/images/new/mall.svg";
import tuneIcon from "../../../../assets/images/new/tune.svg";
import monitorIcon from "../../../../assets/images/new/monitor.svg";
import profile from "../../../../assets/images/new/user-svg.svg";
import quickaccesicon from "../../../../assets/images/new/thunderbolt.svg"
import restoreIcon from "../../../../assets/images/new/restore.png"

import LockIcon from '@mui/icons-material/Lock';

const SideMenuList = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { userdetails } = useSelector((state) => state?.userDetails);
    const menu_data = props.data ? props.data : [];
    const nonVisualizedManager = userdetails?.isVisualize;
    const handleClick = (path) => {
        navigate(path);
    }

    return (
        <>
            <ListItemButton data-menu-path={menu_data?.path} onClick={() => handleClick(menu_data?.path)} className={menu_data?.path === location?.pathname || (location?.pathname === "/legacy_detail" && menu_data?.path === "/legacy_dashboard") ? "menu-toggle menu-header activemenu" : "menu-toggle menu-header"}
                disabled={(nonVisualizedManager === false && props?.icon === "shop") || (nonVisualizedManager === false && props?.icon === "profile") ? false :
                    nonVisualizedManager === false ? true : false} >
                <span className="d-flex justyfy-space-between w-100 drop-svg">
                    {props?.icon === "shop" ? 
                    <img src={mallIcon} alt="shop" className="img-sidemenu" /> 
                    : props?.icon === "dashboard" ? 
                    <img src={tuneIcon} alt="dashboard" className="img-sidemenu" /> 
                    : props?.icon === "profile" ? 
                    <img src={profile} alt="my profile" className="img-sidemenu" />
                    : props?.icon === "quickaccess" ?
                    <img src={quickaccesicon} alt="Quick Access" className='img-sidemenu icon-thunder' />
                    : props?.icon === "legacy"?
                    <img src={restoreIcon} alt="Quick Access" className='img-sidemenu icon-thunder timer-png' />
                    :
                    <img src={monitorIcon} alt="view" className="img-sidemenu w-18px" />
                    }
                    <ListItemText primary={menu_data?.title} className="menu-txt two-headers" />
                    {(nonVisualizedManager === false && props?.icon === "shop") || (nonVisualizedManager === false && props?.icon === "profile") ? "" :
                        nonVisualizedManager === false ? <LockIcon /> : ""}
                </span>
            </ListItemButton>
        </>
    )
}

export default SideMenuList